import axios from 'axios'
import { useEffect, useState } from 'react'
import authService from '../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../Components/Main'
import ProfileDireita from '../../Components/ProfileDireita'
import { NavDireita } from '../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../Components/SideBar-right/SidebarMobile'
import '../../styles/pages/MenuDireito/unidades.css'
import ModalCriar from './MenuDireito-Modal/ModalCadUnidade'
import Modal from './MenuDireito-Modal/ModalEdiUnidade'
import { useNavigate } from 'react-router-dom'

function Unidades() {
  const history = useNavigate()
  var user = authService.getCurrentUser()
  const [unidades, setUnidades] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [modalInfo, setModalInfo] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/unidade/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setUnidades(response.data)
      })
  }, [])
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  function handleToggleLocais(unidade: any = {}) {
    sessionStorage.IdUnidade = unidade.IdUnidade
    sessionStorage.uniRazaoSocial = unidade.uniRazaoSocial
    sessionStorage.uniSubUnidades = unidade.uniSubUnidades
    history('Locais')
  }
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <div className="displayInteract">
      {modalOpen && <Modal setOpenModal={setModalOpen} modalInfo={modalInfo} />}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE UNIDADES</TitlePage1>
            {/* <TitlePage2>Unidades:</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalCriar />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>Locais</th>
              <th>Unidades</th>
              <th>Razão Social</th>
              <th>SubUnidades</th>
              <th>Status</th>
            </thead>
            <tbody>
              {unidades
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.uniNome.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    val.uniRazaoSocial.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    val.uniEndereco.toLowerCase().includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(unidade => (
                  <tr key={unidade.IdUnidade}
                  onClick={() => handleToggleComplete(unidade)}>
                    <td>
                        <button className="btnMGUPermissoes" 
                          key={unidade.IdUnidade}
                          onClick={() => handleToggleLocais(unidade)}>
                          <i className="fas fa-bars"></i>
                        </button>
                    </td>
                    <td>
                      <p>{unidade.uniNome}</p>
                    </td>
                    <td>
                      <p className="Space2">{unidade.uniRazaoSocial}</p>
                    </td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!unidade.uniSubUnidades}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!unidade.uniStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default Unidades
